'use client'
import { useEffect } from 'react'
import { pixelTrack } from '@/components/MetaPixel'

// Fires one Meta standard event when a server-rendered page mounts (e.g.
// ViewContent on /cars/[slug]). Renders nothing; a no-op when no pixel is set.
export default function PixelEvent({ event, params }) {
    // params is a fresh object each render — serialize so the effect keys on the
    // VALUE, otherwise the event re-fires on every re-render.
    const key = JSON.stringify(params || {})
    useEffect(() => {
        pixelTrack(event, JSON.parse(key))
    }, [event, key])
    return null
}
